module.exports = __webpack_public_path__ + "static/img/chat.f8a9b9e0.png";